<template>
  <StandardIconBloc
    icon="x-circle-fill"
    backColor="rgb(255,235,230)"
    frontColor="rgb(222,53,11)"
  >
    <slot></slot>
  </StandardIconBloc>
</template>

<script>
import StandardIconBloc from "./StandardIconBloc.vue";
export default {
  name: "ErrorBloc",
  components: { StandardIconBloc },
};
</script>
